import CircularLoader from '../DisplayGrid/CircularLoader';

const RouteContentFallback = ({
  text = 'Loading page...',
  fullScreen = false,
}) => (
  <div
    className={
      fullScreen
        ? 'flex min-h-screen w-full items-center justify-center'
        : 'relative mt-9 flex min-h-[min(70vh,100%)] w-full min-w-0 flex-1 flex-col rounded-20'
    }
    style={{ background: fullScreen ? '#f6f6f6' : 'rgb(246, 246, 246)' }}
    role="status"
    aria-live="polite"
    aria-busy="true"
  >
    <CircularLoader text={text} uppercase={false} />
  </div>
);

export default RouteContentFallback;
